import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Breadcrumb, Modal } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import axios from 'axios'
import marked from 'marked'
import JSONPretty from 'react-json-pretty';
import { slugify } from '../libs/utils'

class Document extends Component {

  state = {
    ready_for_render: false,
    api_test_response: null,
    modal_visible: false,
    modal_loading: true
  }

  constructor(props, context) {
    
    super(props, context);
    
    this.rawMarkup = this.rawMarkup.bind(this);
    
  }
  
  componentDidMount(){
    
    window.scrollTo(0, 0)
    
  }

  btnTimer = null
  
  componentDidUpdate(){

    clearTimeout(this.btnTimer)
    
    this.btnTimer = setTimeout(() => {
      
      var btns = document.getElementsByClassName('run')
      var me = this
      
      for(var i = 0; i < btns.length; i++)
        btns[i].onclick = function(){
          me.runApiTest(this.getAttribute('data-url'))
        }
  
    }, 1000)

  
  }
  
  runApiTest(url){
    
    // console.log('url', url)
  
    this.setState({ modal_visible: true, modal_loading: true, api_test_response: null })
    
    axios.get('https://holdmyticket.com/'+url)
    .then((response) => {
      this.setState({ modal_visible: true, modal_loading: false, api_test_response: response.data })
    })
    .catch(function (error) {
      console.log(error);
    })
    
  }

  componentWillMount(){

    this.props.store.document.fetch(this.props.match.params.id)
    
    window.scrollTo(0, 0)
  
  }
  
  rawMarkup() {
    
    var content = ''
    if(this.props.store.document.read.content_markdown)
      content = this.props.store.document.read.content_markdown
    
    let rawMarkup = marked(content, {sanitize: false});
    
    return { __html: rawMarkup };
    
  }
  
  closeModal = (e) => {
    
    this.setState({ modal_visible: false })
    
  }
  
  render(){
    
    if(!this.props.store.document.read || !this.props.store.document.read.id)
      return (<div>Loading</div>)

    var doc = this.props.store.document.read

    return (
            
      <div style={{ textAlign: 'left' }}>

        <Breadcrumb separator="&rarr;">
          <Breadcrumb.Item><a href="/">Home</a></Breadcrumb.Item>
          <Breadcrumb.Item><a href={"/"+slugify(doc.main_category)}>{doc.main_category}</a></Breadcrumb.Item>
          <Breadcrumb.Item className="spot1"><a href={"/"+slugify(doc.main_category)+"/"+slugify(doc.category)}>{doc.category}</a></Breadcrumb.Item>
        </Breadcrumb>
        
        <br /><br />

        <h1>{doc.title}</h1>
        
        <Modal
          title="API Test Response"
          visible={this.state.modal_visible}
          onOk={this.closeModal}
          onCancel={this.closeModal}
        >
          
          {this.state.modal_loading ? 
            <LoadingOutlined /> : 
            <JSONPretty id="json-pretty" json={this.state.api_test_response}></JSONPretty>
          }
          
        </Modal>
        
        <div className="documentInner">
          <span dangerouslySetInnerHTML={this.rawMarkup()} />
        </div>
        
      </div>
  
    )
    
  }
  
}

export default observer(Document)